export default "__VITE_ASSET__38021eb0__"